export default `float s=3.; p=abs(p);
    for (float i=0.; i<9.; i++){
      p-=clamp(p,-1.,1.)*2.;
      float r=6.62*clamp(.12/min(dot(p,p),1.),0.,1.);
      s*=r; p*=r; p+=1.5;
    }
    s=abs(s); float a=.8;
    p-=clamp(p,-a,a);
    return length(p)/s;
  }`